import { createContext, useContext, useState, useLayoutEffect, useCallback } from "react";

const ThemeContext = createContext(null);

// Check localStorage before React mounts to prevent flash
const getInitialTheme = () => {
  if (typeof window !== 'undefined') {
    const stored = localStorage.getItem("maaly-theme");
    return stored || "dark";
  }
  return "dark";
};

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(getInitialTheme);

  // Apply theme to DOM whenever it changes
  useLayoutEffect(() => {
    const root = document.documentElement;
    root.classList.remove("light", "dark");
    root.classList.add(theme);
    localStorage.setItem("maaly-theme", theme);
  }, [theme]);

  // Memoize setTheme to ensure stable reference
  const setTheme = useCallback((newTheme) => {
    setThemeState(newTheme);
  }, []);

  // Toggle function
  const toggleTheme = useCallback(() => {
    setThemeState(prev => prev === "dark" ? "light" : "dark");
  }, []);

  const value = { theme, setTheme, toggleTheme };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
}
